module.exports = __webpack_public_path__ + "static/img/zhongliang.bfbf6b17.png";